import {
    formatDateTimeIntoDate,
    getTodayDatePlusOneYear,
    hasTheDateAlreadyPassed,
    isDateTimeWithinDaysAhead
} from '../../helpers/DateHelper';

export default {
    data: () => {
        return {
            ABOUT_TO_EXPIRE_DAYS_TO_CONSIDER: 30,
            STATUS_DATA: {
                ABOUT_TO_EXPIRE: {
                    color: 'rgb(251, 192, 45)',
                    label: 'Tarifa a expirar',
                    info: 'Essa tarifa está prestes a expirar ' +
                        '(daqui a 30 dias ou menos). Entre em ' +
                        'contato com o responsável pelo hotel, ' +
                        'atualize o valor e renove a validade.'
                },
                EXPIRED: {
                    color: '#fb8c00',
                    label: 'Tarifa expirada',
                    info: 'Essa tarifa expirou. Entre em contato ' +
                        'com o responsável pelo hotel, atualize ' +
                        'o valor e renove a validade.'
                },
                NON_EXPIRED: {
                    color: 'rgb(76, 175, 80)',
                    label: 'Tarifa vigente',
                    info: 'Essa tarifa está vigente e dentro do ' +
                        'prazo de validade. Nenhuma ação é necessária.'
                },
                PENDING_UPDATE: {
                    color: 'rgb(25, 118, 210)',
                    label: 'Tarifa alterada, necessita confirmação',
                    info: 'Essa tarifa teve alguma de suas informações alteradas, ' +
                        'mas os dados ainda não foram persistidos. ' +
                        'Conclua a atualização dos dados do hotel ' +
                        'para finalizar.'
                }
            },
            roomFareStatus: null,
        };
    },
    computed: {
        isFareExpired() {
            return this.roomFare !== null ?
                hasTheDateAlreadyPassed(this.roomFare.expiration_date) :
                false;
        },
        isFareAboutToExpire() {
            return this.roomFare !== null ?
                isDateTimeWithinDaysAhead(
                    this.roomFare.expiration_date,
                    this.ABOUT_TO_EXPIRE_DAYS_TO_CONSIDER
                ) :
                false;
        },
        hasFareStatus() {
            return this.roomFareStatus !== null;
        },
        statusColor() {
            return this.hasFareStatus ?
                this.STATUS_DATA[this.roomFareStatus].color :
                '';
        },
        statusLabel() {
            return this.hasFareStatus ?
                this.STATUS_DATA[this.roomFareStatus].label :
                '';
        },
        infoTooltipLabel() {
            return this.hasFareStatus ?
                this.STATUS_DATA[this.roomFareStatus].info :
                '';
        },
        cssVars() {
            return {
                '--fare-status-color': this.statusColor
            };
        }
    },
    methods: {
        setRoomFareStatusByExpirationDate() {
            if (this.isFareExpired) {
                this.setRoomFareStatus('EXPIRED');
            } else if (this.isFareAboutToExpire) {
                this.setRoomFareStatus('ABOUT_TO_EXPIRE');
            } else {
                this.setRoomFareStatus('NON_EXPIRED');
            }
        },
        setRoomFarePendingUpdateStatus() {
            this.setRoomFareStatus('PENDING_UPDATE');
        },
        setRoomFareStatus(status) {
            this.roomFareStatus = this.validateStatus(status) ? status : null;
        },
        validateStatus(status) {
            return this.STATUS_DATA.hasOwnProperty(status);
        },
        formatDateTimeIntoDate(date) {
            return formatDateTimeIntoDate(date);
        },
        setDefaultExpirationDate() {
            this.expirationDate = getTodayDatePlusOneYear();
        },
        hotelHasExpiredFares(hotel) {
            return !!hotel.expired_fares_count;
        },
        hotelHasAboutToExpireFares(hotel) {
            return !!hotel.about_to_expire_fares_count;
        },
        getListHotelsFareStatusBadgeColor(hotel) {
            if (
                (
                    this.hotelHasExpiredFares(hotel) &&
                    this.hotelHasAboutToExpireFares(hotel)
                ) || this.hotelHasExpiredFares(hotel)
            ) {
                return this.STATUS_DATA.EXPIRED.color;
            } else if (this.hotelHasAboutToExpireFares(hotel)) {
                return this.STATUS_DATA.ABOUT_TO_EXPIRE.color;
            }

            return this.STATUS_DATA.NON_EXPIRED.color;
        },
        getListHotelsFareStatusBadgeLabel(hotel) {
            if (
                this.hotelHasExpiredFares(hotel) &&
                this.hotelHasAboutToExpireFares(hotel)
            ) {
                return 'A Expirar e Expiradas';
            } else if (this.hotelHasAboutToExpireFares(hotel)) {
                return 'A Expirar';
            } else if (this.hotelHasExpiredFares(hotel)) {
                return 'Expiradas';
            }

            return 'Vigentes';
        },
        getListHotelsFareStatusBadgeTooltipLabel (hotel) {
            if (
                this.hotelHasExpiredFares(hotel) &&
                this.hotelHasAboutToExpireFares(hotel)
            ) {
                return 'Este hotel possui tarifas prestes a expirar, ' +
                    'expiradas e pode ter tarifas vigentes';
            } else if (this.hotelHasAboutToExpireFares(hotel)) {
                return 'Este hotel possui uma ou mais tarifas prestes ' +
                    'a expirar, nenhuma tarifa expirada e pode ter ' +
                    'tarifas vigentes';
            } else if (this.hotelHasExpiredFares(hotel)) {
                return 'Este hotel possui uma ou mais tarifas expiradas, ' +
                    'nenhuma tarifa prestes a expirar e pode ter ' +
                    'tarifas vigentes';
            }

            return 'Todas as tarifas deste hotel estão ' +
                'vigentes (dentro do prazo de validade).';
        }
    },
};
